import { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { searchProducts } from '../services/productService';
import { useMarket } from '../context/MarketContext';
import ProductGrid from '../components/product/ProductGrid';

const SearchPage = () => {
  const [searchParams] = useSearchParams();
  const query = searchParams.get('q') || '';
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const { currentMarket } = useMarket();
  const marketCode = currentMarket?.isDefault ? null : currentMarket?.code;

  useEffect(() => {
    if (!query) { setResults([]); return; }
    setLoading(true);
    searchProducts(query, marketCode).then(setResults).catch(() => setResults([])).finally(() => setLoading(false));
  }, [query, marketCode]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <Helmet>
        <title>{(query ? `"${query}" — Search Results` : 'Search') + ' — Skinn Thrive'}</title>
      </Helmet>
      <div className="max-w-7xl mx-auto px-4 py-10">
        <div className="mb-8">
          <h1 className="text-2xl font-bold text-gray-900">
            {query ? <>Search results for "<span className="text-primary">{query}</span>"</> : 'Search Products'}
          </h1>
          {query && !loading && <p className="text-gray-500 mt-1">{results.length} result{results.length !== 1 ? 's' : ''} found</p>}
        </div>
        {!query ? (
          <div className="text-center py-16">
            <div className="text-5xl mb-3">🔍</div>
            <p className="text-gray-500">Type something in the search bar to find products.</p>
          </div>
        ) : loading ? (
          <div className="text-center py-16 text-gray-400">Searching...</div>
        ) : (
          <ProductGrid products={results} emptyMessage={`No products found for "${query}". Try a different keyword.`} />
        )}
      </div>
    </>
  );
};

export default SearchPage;
